// extracted by mini-css-extract-plugin
export default {"both_side":"ProfilePage_both_side__0X2zC","left_side":"ProfilePage_left_side__KkLYF","right_side":"ProfilePage_right_side__y5oyy"};